<template>
  <div class="container">
    <div class="row">
      <div class="col-12 pb-4 pt-4">
        <app-table
          v-show="!loading"
          :apps="getApplications"
          :columns="columns"
          :sort-options="sortOptions"
          :pagination-options="paginationOptions"
          :onPaginationChangeFunc="onPaginationChange"
          :onSortChangeFunc="onSortChange"
        ></app-table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import util from "@/util";
import * as CONSTANTS from "../constants.js";
import AppHandlerMixin from "@/mixins/AppHandlerMixin";
import AppTable from "@/components/AppTable";

export default {
  name: "All",
  components: {
    AppTable
  },
  mixins: [AppHandlerMixin],
  data: function() {
    return {
      CONSTANTS,
      loading: true,
      columns: [
        {
          label: "Favorite",
          field: "favorite",
          sortFn: util.favoriteSort
        },
        {
          label: "Title",
          field: "title"
        },
        {
          label: "Description",
          field: "tag_line"
        },
        {
          label: "Type",
          field: "type"
        },
        {
          label: "Access",
          field: "access.last_accessed",
          sortFn: util.accessStateSort
        },
        {
          label: 'Entitlement',
          field: 'access.state',
          sortFn: util.entitlementSort
        },
        {
          label: "Link",
          field: "root_link",
          sortable: false
        }
      ],
      paginationOptions: {
        enabled: true,
        mode: "records",
        perPage: 50,
        position: "bottom",
        perPageDropdown: [50, 100],
        dropdownAllowAll: true,
        setCurrentPage: 1,
        nextLabel: "next",
        prevLabel: "prev",
        rowsPerPageLabel: "Rows per page",
        ofLabel: "of",
        pageLabel: "page",
        allLabel: "All"
      },
      sortOptions: {
        enabled: true,
        initialSortBy: { field: "title", type: "asc" }
      },
      downloadModel: null
    };
  },
  computed: {
    ...mapGetters([
      "getViewType",
      "getApplications",
      "getApplicationById",
      "getPreviousAllTablePage",
      "getPreviousAllTablePerPage",
      "getPreviousAllTableSortOpts"
    ])
  },
  created() {
    // mask page change load time in vue-good-table
    if (this.getPreviousAllTablePage > 1) {
      setTimeout(() => {
        this.loading = false;
        window.scroll(window.scrollX, window.scrollY+1)
      }, 600);
    } else {
      this.loading = false;
    }
    this.paginationOptions.perPage = this.getPreviousAllTablePerPage;
    this.paginationOptions.setCurrentPage = this.getPreviousAllTablePage;
    this.sortOptions = this.getPreviousAllTableSortOpts;
  },
  methods: {
    ...mapMutations([
      "setPreviousAllTablePage",
      "setPreviousAllTablePerPage",
      "setPreviousAllTableSortOpts"
    ]),
    setModel(model) {
      this.downloadModel = this.getApplicationById(model.id);
      this.downloadModel.show = true;
    },
    onPaginationChange(params) {
      if (params.prevPage) {
        this.setPreviousAllTablePage(params.currentPage);
        this.setPreviousAllTablePerPage(params.currentPerPage);
      } else if (params.currentPerPage != this.getPreviousAllTablePerPage) {
        this.setPreviousAllTablePage(1);
        this.setPreviousAllTablePerPage(params.currentPerPage);
      }

    },
    onSortChange(params) {
      let tmp = {
        enabled: true,
        initialSortBy: {
          field: this.columns[params.columnIndex].field,
          type: params.sortType
        }
      };
      this.setPreviousAllTableSortOpts(tmp);
      this.setPreviousAllTablePage(1);
    }
  }
};
</script>
<style scoped>
.has-access-container svg {
  width: 7px;
  float: left;
  color: #7ed321;
}
.has-access-container .access-text {
  font-size: 11px;
  color: #7ed321;
  float: left;
  padding-right: 5px;
  font-weight: bold;
}
.unknown-access-text {
  font-size: 11px;
  color: #575757;
  font-weight: bold;
}
.category-container {
  margin-bottom: 25px;
}
</style>
